import { Container } from "@movicoders/di";
import { IRepository } from "@movicoders/domain";

import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useResourceContext } from "../../Resources";

import { GetImplementedEntityType, ObjectType } from "../types";

export const useDetailViewModel = <R extends IRepository<any, any, any>>(
  RType: ObjectType<R>
) => {
  const resource = useResourceContext();

  type E = GetImplementedEntityType<R>;

  const repository = Container.resolve<R>(RType as any);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({} as E);
  const { id } = useParams();

  const fetch = useCallback(async () => {
    setLoading(true);

    await repository.getById(id!)
      .then((response: any) => setData(response))
      .finally(() => setLoading(false));
  }, [id]);

  useEffect(() => {
    if (!!id) fetch();
  }, [id, fetch]);

  const save = async (entity: E) => {
    setLoading(true);

    if (id) {
      await repository.update(entity);
    } else {
      await repository.create(entity);
    }

    setLoading(false);

    goToList();
  }

  const goToList = () => {
    navigate(`/${resource}`);
  };

  return { data, loading, fetch, goToList, save };
};
